'use strict';

define('lib/analytics/blocks/section.block',[], function () {
  return function sectionBlock(name) {
    return { content_section: name };
  };
});

